import React, { useState, useEffect, useCallback, useRef } from 'react';
import '../../../../styles/count_graphs.css'
import LprCountAnalytics from './LprCount/LprCountAnalytics';
import LprOccupancyAnalytics from './LprOccupancy/LprOccupancyAnalytics';
import NoDataUpgradePrompt from '../../NoData';
import Tooltip from '../../../../ui-components/Tooltip/Tooltip';


const LprBaseSuite = ({
  selectedSite,
  selectedCamera,
  selectedSuite,
  selectedYear,
  selectedCameraId = 'All',
}) => {

  const [isCountExpanded, setIsCountExpanded] = useState(true);
  const [isOccupancyExpanded, setIsOccupancyExpanded] = useState(true);

  const [hasLprCountData, setHasLprCountData] = useState(null);
  const [hasLprOccupancyData, setHasLprOccupancyData] = useState(null);

  const prevCameraRef = useRef(selectedCameraId);
  const prevHwidRef = useRef(selectedSite.hwid);

  useEffect(() => {
    if (selectedCameraId !== prevCameraRef.current || selectedSite.hwid !== prevHwidRef.current) {
      setHasLprCountData(true);
      setHasLprOccupancyData(true);
      setIsCountExpanded(true);
      setIsOccupancyExpanded(true);
      prevCameraRef.current = selectedCameraId;
      prevHwidRef.current = selectedSite.hwid;
    }
  }, [selectedCameraId, selectedSite]);

  const handleCountDataState = (hasData) => {
    setHasLprCountData(hasData);
  };

  const handleOccupancyDataState = (hasData) => {
    setHasLprOccupancyData(hasData);
    setIsOccupancyExpanded(hasData);
  };

  return (
    <div className="graphs-container" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

      {selectedSite && selectedCamera && selectedSuite && (
        <>
          <div style={{ width: '90%', margin: '20px 0', textAlign: 'left', position: 'relative', cursor: 'pointer' }}
          onClick={() => setIsCountExpanded(!isCountExpanded)}>
            <div style={{ display: 'inline-block', padding: '0 10px', background: '#2B3441', position: 'relative', zIndex: 1,  boxShadow: `0px 5px 15px ${isCountExpanded ? 'rgba(255, 165, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)'}` }}>
              <Tooltip content="License Plate Count Analytics per month, week and day per camera" >
                <span style={{ fontSize: '1.2em', color: hasLprCountData ? 'white' : 'grey' }}>LPR Count Analytics {isCountExpanded ? '▲' : '▼'}</span>
              </Tooltip>
            </div>
            <div style={{ position: 'absolute', top: '50%', left: '0', right: '0', height: '0px', background: '#2B3441',  boxShadow: `0px 5px 15px ${isCountExpanded ? 'rgba(255, 165, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)'}`,  zIndex: 0 }} />
          </div>

          {(isCountExpanded && (hasLprCountData === true || hasLprCountData === null)) && (
            <div style={{ width: '90%' }}>
              <LprCountAnalytics
                selectedSite={selectedSite}
                selectedCamera={selectedCamera}
                selectedCameraId={selectedCameraId}
                selectedYear={selectedYear}
                handleCountDataState={handleCountDataState}
              />
            </div>
          )}
          {isCountExpanded && hasLprCountData === false && (
            <div style={{ width: '90%' }}>
              <NoDataUpgradePrompt title="Lpr Count Analytics" />
            </div>
          )}
          <div style={{ width: '90%', margin: '20px 0', textAlign: 'left', position: 'relative', cursor: 'pointer' }}
          onClick={() => setIsOccupancyExpanded(!isOccupancyExpanded)}>
            <div style={{ display: 'inline-block', padding: '0 10px', background: '#2B3441', position: 'relative', zIndex: 1,  boxShadow: `0px 5px 15px ${isOccupancyExpanded ? 'rgba(255, 165, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)'}` }}>
              <Tooltip content="LPR Occupancy Analytics showing number of times occupancy threshold exceeded" >
                <span style={{ fontSize: '1.2em', color: hasLprOccupancyData ? 'white' : 'grey' }}>LPR Occupancy Analytics {isOccupancyExpanded ? '▲' : '▼'}</span>
              </Tooltip>
            </div>
            <div style={{ position: 'absolute', top: '50%', left: '0', right: '0', height: '0px', background: '#2B3441',  boxShadow: `0px 5px 15px ${isOccupancyExpanded ? 'rgba(255, 165, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)'}`,  zIndex: 0 }} />
          </div>

          {(isOccupancyExpanded && (hasLprOccupancyData === true || hasLprOccupancyData === null)) && (
            <div style={{ width: '90%' }}>
              <LprOccupancyAnalytics
                selectedSite={selectedSite}
                selectedCameraId={selectedCameraId}
                selectedYear={selectedYear} 
                handleOccupancyDataState={handleOccupancyDataState}
              />
            </div>
          )}
          {isOccupancyExpanded && hasLprOccupancyData === false && (
            <div style={{ width: '90%' }}>
              <NoDataUpgradePrompt title="Lpr Occupancy Analytics" />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LprBaseSuite;